import { loadStripe } from '@stripe/stripe-js';

/**
 * Loads Stripe.js once, using the publishable key served by the backend
 * (/api/config/stripe) so there's a single .env to maintain.
 */
let stripePromise = null;

export const getStripePromise = () => {
    if (!stripePromise) {
        stripePromise = fetch('/api/config/stripe')
            .then((res) => res.json())
            .then(({ publishableKey }) => (publishableKey ? loadStripe(publishableKey) : null))
            .catch(() => null)
            .then((stripe) => {
                if (!stripe) stripePromise = null; // allow a retry on the next call
                return stripe;
            });
    }
    return stripePromise;
};

// RetroDayz look for Stripe Elements — matches the approved checkout design
export const stripeAppearance = {
    theme: 'stripe',
    variables: {
        colorPrimary: '#1A1A1A',
        colorText: '#1A1A1A',
        colorTextSecondary: '#4A4A48',
        colorBackground: '#FFFFFF',
        colorDanger: '#B42318',
        fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif", // same as the rest of the site
        fontSizeBase: '16px', // 16px+ stops iPhones zooming in when a field is tapped
        borderRadius: '10px',
        spacingUnit: '4px',
        focusBoxShadow: '0 0 0 3px rgba(62, 109, 156, 0.18)',
        focusOutline: 'none',
    },
    rules: {
        '.Input': {
            border: '1px solid #D6D4CC',
            boxShadow: 'none',
            padding: '13px 14px',
        },
        '.Input:focus': {
            borderColor: '#3E6D9C',
        },
        '.Label': {
            fontWeight: '500',
            color: '#4A4A48',
        },
        '.AccordionItem': {
            border: '1px solid #D6D4CC',
            borderRadius: '14px',
            boxShadow: 'none',
            padding: '16px 18px',
        },
        '.AccordionItem--selected': {
            borderColor: '#1A1A1A',
            boxShadow: '0 0 0 1px #1A1A1A',
        },
    },
};

// The site uses system fonts, so Stripe needs nothing extra loaded
export const stripeFonts = [];
